import i18n from "i18next";

i18n.init({
    // we init with resources
    resources: {
        en: {
            translations: {
                "Sign up": "Sign up",
                "Required fields are indicated with \"*\"": "Required fields are indicated with \"*\"",
                "E-mail": "Email",
                "Name": "Name",
                "Surname": "Last name",
                "Password": "Password",
                "Password length": 'Please use 8 or more characters',
                "Communication": 'Error occurred when send data. Please try later.',
                'Errors_name': 'Name is required',
                'Errors_surname': 'Last name is required',
                'Errors_email': 'E-mail is required',
                'Errors_password': 'Password must be at least 8 characters long',
            }
        },
        ru: {
            translations: {
                "Sign up": "Регистрация",

            }
        },

    },
    fallbackLng: "en",
    debug: true,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },

    react: {
        wait: true
    }
});

export default i18n;
